<template>
  <ErrorPageLayout>
    <template #heading>
      <AppHeading tag="h1" text="¡Uh-Oh!" />
      <p>{{ $t('ui.network_error.message') }}</p>
    </template>
    <template #details>
      <AppRouterLink exact :to="backRoute">
        {{ $t('ui.network_error.retry') }}
      </AppRouterLink>
    </template>
    <template #image>
      <img :src="imageFile" />
    </template>
  </ErrorPageLayout>
</template>

<script>
// Utilities
import NetworkErrorPageImage from 'Images/components/network-error.png'
// Components
import AppHeading from 'Ui/AppHeading'
import AppRouterLink from 'Ui/AppRouterLink'
import ErrorPageLayout from 'Layouts/ErrorPageLayout'

export default {
  name: 'NetworkErrorPagePage',

  components: {
    AppHeading,
    AppRouterLink,
    ErrorPageLayout,
  },

  data() {
    return {
      fromRoute: null,
    }
  },

  computed: {
    imageFile() {
      return NetworkErrorPageImage
    },

    backRoute() {
      return this.fromRoute ? this.fromRoute : { name: 'dashboard' }
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from && !from.name?.includes('404')) {
        vm.$data.fromRoute = from
      }
    })
  },
}
</script>

<style scoped>
.app-heading {
  margin-bottom: 10px;
}
</style>
